import { LocalStorageService } from '@/shared/services/localStorage.service';
import { routerPath } from '@/shared/config/router';

const SSO_TOKEN_KEYS = ['token', 'accessToken', 'jwt'] as const;

// Там `token` — одноразовый код из письма, а не сессия: забирать его в хранилище нельзя
const AUTH_CODE_PATHS = [
  routerPath.resetPassword,
  routerPath.setPassword,
  routerPath.confirmEmail,
  routerPath.activate,
] as const;

export const syncSsoTokenFromUrl = () => {
  if (typeof window === 'undefined') return false;

  const { pathname } = window.location;
  if (AUTH_CODE_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))) {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const token = SSO_TOKEN_KEYS.map((key) => params.get(key)).find(Boolean);

  if (!token) return false;

  LocalStorageService.setAccessToken(token);
  localStorage.setItem('isAuth', 'true');
  sessionStorage.setItem('isAuth', 'true');

  SSO_TOKEN_KEYS.forEach((key) => params.delete(key));
  const query = params.toString();
  const nextUrl = `${pathname}${query ? `?${query}` : ''}${window.location.hash}`;
  window.history.replaceState({}, '', nextUrl);

  return true;
};
